import React from 'react';
import KonteringSlip from './KonteringSlip';
import { formatDate } from './bankFormat';

// Counter accounts of a historical verifikat, in the order the slip shows them.
function accountSummary(rows) {
    return [...new Set(rows.map(row => String(row.account_number)))].sort().join(' / ');
}

/**
 * The precedents behind a history proposal — factual examples with their
 * original amounts, never a booking or linking action. Each is one line
 * (number · date · accounts) that expands to the original kontering; the
 * proposal above already shows the accounts, so nothing is open by default.
 */
export default function HistoricalBookingEvidence({ neighbors, busy, onOpen }) {
    if (!Array.isArray(neighbors) || neighbors.length === 0) return null;

    return (
        <section aria-label="Tidigare bokföring" style={{ marginTop: 14, fontSize: '0.75rem', color: '#374151' }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                Tidigare bokföring
            </div>
            {neighbors.map((neighbor, index) => {
                const rows = Array.isArray(neighbor.postingRows) ? neighbor.postingRows : [];
                const number = neighbor.number || 'Verifikat';
                return (
                    <details key={neighbor.id || index} style={{ borderTop: index > 0 ? '1px solid #f3f4f6' : 'none', padding: '6px 0' }}>
                        {/* Native disclosure marker kept for affordance; the line itself is one inline-flex. */}
                        <summary style={{ cursor: 'pointer' }}>
                            <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: 8, width: 'calc(100% - 20px)', verticalAlign: 'top' }}>
                                <span style={{ fontWeight: 600, color: '#111827' }}>{number}</span>
                                {neighbor.date && <span style={{ color: '#6b7280', fontVariantNumeric: 'tabular-nums' }}>{formatDate(neighbor.date)}</span>}
                                {rows.length > 0 && <span style={{ color: '#6b7280', fontVariantNumeric: 'tabular-nums' }}>{accountSummary(rows)}</span>}
                                {neighbor.description && (
                                    <span style={{ color: '#9ca3af', flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {neighbor.description}
                                    </span>
                                )}
                            </span>
                        </summary>
                        {rows.length > 0
                            ? <KonteringSlip rows={rows} dense />
                            : <p style={{ margin: '6px 0 0', color: '#6b7280' }}>Öppna verifikatet för att se konteringen.</p>}
                        <button type="button" className="btn btn-link btn-sm px-0" style={{ fontSize: '0.75rem' }} disabled={busy || !neighbor.id || !onOpen} onClick={() => onOpen(neighbor)}>
                            Öppna {number}
                        </button>
                    </details>
                );
            })}
        </section>
    );
}
